import React from 'react';
import Box from '@mui/material/Box';
import DayScheduleRow from './DayScheduleRow';

const DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export default function WeeklyScheduleGrid({ schedule, onChange }) {
  // Handle changes to a specific day
  const handleDayChange = (dayIndex, daySchedule) => {
    const newSchedule = {
      ...schedule,
      days: schedule.days.map((day, index) => 
        index === dayIndex ? daySchedule : day
      )
    };
    onChange(newSchedule);
  };

  // Copy periods from one day to others
  const handleCopyToAll = (sourceDayIndex) => {
    const sourcePeriods = schedule.days[sourceDayIndex].periods;
    const sourceEnabled = schedule.days[sourceDayIndex].enabled;
    
    const newSchedule = {
      ...schedule,
      days: schedule.days.map((day, index) => ({
        enabled: sourceEnabled,
        periods: [...sourcePeriods.map(p => ({ ...p }))]
      }))
    };
    onChange(newSchedule);
  };

  // Copy to weekdays only
  const handleCopyToWeekdays = (sourceDayIndex) => {
    const sourcePeriods = schedule.days[sourceDayIndex].periods;
    const sourceEnabled = schedule.days[sourceDayIndex].enabled;
    
    const newSchedule = {
      ...schedule,
      days: schedule.days.map((day, index) => {
        // Monday (1) to Friday (5)
        if (index >= 1 && index <= 5) {
          return {
            enabled: sourceEnabled,
            periods: [...sourcePeriods.map(p => ({ ...p }))]
          };
        }
        return day;
      })
    };
    onChange(newSchedule);
  };

  return (
    <Box>
      {/* Time axis header */}
      <Box sx={{ 
        display: 'flex', 
        mb: 1,
        pl: '140px', // Align with day rows
        pr: 2
      }}>
        {[0, 3, 6, 9, 12, 15, 18, 21, 24].map((hour) => (
          <Box 
            key={hour}
            sx={{ 
              flex: hour === 24 ? 'none' : 1,
              textAlign: 'left',
              position: 'relative'
            }}
          >
            <Box
              sx={{
                fontSize: '0.7rem',
                color: 'text.secondary',
                position: 'absolute',
                left: hour === 0 ? 0 : '-12px',
                whiteSpace: 'nowrap'
              }}
            >
              {hour.toString().padStart(2, '0')}:00
            </Box>
          </Box>
        ))}
      </Box>

      {/* Day rows */}
      <Box sx={{ mt: 3 }}>
        {DAY_NAMES.map((dayName, index) => (
          <DayScheduleRow
            key={dayName}
            dayName={dayName}
            dayIndex={index}
            daySchedule={schedule.days[index]}
            onChange={(newDaySchedule) => handleDayChange(index, newDaySchedule)}
            onCopyToAll={() => handleCopyToAll(index)}
            onCopyToWeekdays={() => handleCopyToWeekdays(index)}
          />
        ))}
      </Box>
    </Box>
  );
}

